
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Manager, Project, User } from '@/generated/graphql';
import ManagerResendInvitation from '@/components/invite/ManagerResendInvitation.vue';
import ResendInvitationWrapper from '@/components/invite/ResendInvitationWrapper.vue';
import ContractorResendInvitation from "@/components/invite/ContractorResendInvitationNew.vue";
import ManagerInvitationDisabledTooltip from '@/components/managers/ManagerInvitationDisabledTooltip.vue';

@Component({
	components: {
		ManagerResendInvitation,
		ResendInvitationWrapper,
		ManagerInvitationDisabledTooltip,
		ContractorResendInvitation,
	},
})
export default class ActionSection extends Vue {
	@Prop({ type: Object, required: true }) readonly actionObject!: object;
	@Prop({ type: String, default: false}) readonly isContractor!: string;
	@Prop({ type: String }) readonly parentStyle!: string;
	@Prop({ type: Object}) readonly contractor!: Object;
	@Prop({ type: String}) readonly companyId!: string;
	@Prop({ type: String}) readonly contractorId!: string;
	@Prop({ type: String }) readonly mainContainerStyle!: string;
	@Prop({ type: Object, required: true }) readonly manager!: Manager;
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: String }) readonly resourceHeight!: string;
	@Prop({ type: Function, default: undefined })
	onActivateManager?: Function;

}
